import { z } from 'zod';
import { CareDocumentCheckableItemSchema } from '../CareDocumentCheckableItemSchema';

export const EndOfCareSummaryReturnToWorkSchema = z.object({
  returnToWork: CareDocumentCheckableItemSchema,
  returnToWorkDateAgreed: CareDocumentCheckableItemSchema,
  intendsToReturnToWork: CareDocumentCheckableItemSchema,
  caseManagerReview: CareDocumentCheckableItemSchema,
});

export type EndOfCareSummaryReturnToWork = z.infer<
  typeof EndOfCareSummaryReturnToWorkSchema
>;

export const isReturnToWorkStatusEmpty = (rtw: EndOfCareSummaryReturnToWork) =>
  !rtw.caseManagerReview.checked &&
  !rtw.intendsToReturnToWork.checked &&
  !rtw.returnToWork.checked &&
  !rtw.returnToWorkDateAgreed.checked;
